import InputFile from '@anm/components/InputFile';
import ProgressButton from '@anm/components/buttons/ProgressButton';
import { UserContext } from '@anm/components/user/UserProvider';
import useStorageCheck from '@anm/hooks/useStorageCheck';
import { useContext, FC } from 'react';

import { ButtonWrapper, Label, PreparingMedia } from './Wrapper';
import getExtensions from './helpers/getExtensions';
import useButtonHandler from './hooks/useButtonHandler';
import useUploadVideo from './hooks/useUploadVideo';
import { UploadMediaProps } from './types';

const UploadButton: FC<UploadMediaProps> = ({
  multiple = false,
  uploadType = ['video'],
  renderChildren,
  ...otherProps
}) => {
  const { anon, isUserLogged } = useContext(UserContext);
  const [labelRef, handleClick] = useButtonHandler();
  const [checkStorage, renderStorageModal] = useStorageCheck();
  const [
    progressValue,
    handleFileChange,
    filesCount,
    currentUploadIndex,
    preparedMedia,
    convertToMP4Modal
  ] = useUploadVideo({
    checkStorage,
    ...otherProps
  });

  const extensionsList = getExtensions(uploadType);

  const filteredExtensions =
    otherProps.onUpload === 'convertToMP4'
      ? extensionsList
          .split(',')
          .filter(ext => ext !== '.mp4')
          .join()
      : extensionsList;

  return (
    <>
      {convertToMP4Modal}
      {renderStorageModal()}
      {!!progressValue ? (
        <ProgressButton
          {...{ totalFiles: filesCount, currentUploadIndex, progressValue }}
          variant={otherProps.variant}
        />
      ) : preparedMedia ? (
        <PreparingMedia variant="yellow" size="large" icon="images/icons/icon_replace.svg">
          Preparing {preparedMedia}
        </PreparingMedia>
      ) : (
        <Label ref={labelRef}>
          <InputFile
            handleUpload={handleFileChange}
            accept={filteredExtensions}
            disabled={!!progressValue}
            multiple={multiple}
          />
          {renderChildren?.(handleClick) || (
            <ButtonWrapper isPending={anon.isPending} onClick={handleClick} isLogged={isUserLogged} {...otherProps}>
              {otherProps.text || 'Upload video'}
            </ButtonWrapper>
          )}
        </Label>
      )}
    </>
  );
};

export default UploadButton;
